import { Box, ModalHeader, Typo } from '@wrisk/ui-components'
import React from 'react'

export const UnauthorizedModalContent = () => (
  <Box>
    <ModalHeader header='Unauthorised' />
    <Typo>You are not authorised to perform this action.</Typo>
  </Box>
)
